import './action.scss'

import {wrap} from '@codeurs/front'
import {ActionChannelData} from 'campagne/types'
import queryString from 'query-string'
import React, {FunctionComponent} from 'react'
import {style} from 'util/campagne/style'
import {Layout} from 'views/campagne/layout'
import {ActionDetail} from 'views/campagne/partials/actions/actiondetail'
import {Actionthanks} from 'views/campagne/partials/actions/actionthanks'
import {RegisterActionForm} from './registeraction'

const styles = style('action')

export const Action: FunctionComponent<ActionChannelData> = wrap(Layout)(
	({form_ordened, channel, ...rest}) => {
		const params = queryString.parse(location.search)
		switch (params.action) {
			case 'edit':
				return (
					<div class={styles}>
						<RegisterActionForm
							editing={params.token}
							orderedForm={form_ordened}
							{...rest}
						/>
					</div>
				)
			case 'thanks':
				return (
					<div class={styles}>
						<Actionthanks {...rest} />
					</div>
				)
			default:
				return <ActionDetail {...rest} />
		}
	}
)
